import Utility from '../../util/utilityfunctions';
import {jsonDocumentPatchOperations} from '../../util/uiconstants';

export const patchGeneratorPayload = (payload) => {
	const properties = Object.keys(payload);
	let data = [];
	properties.forEach((property) => {
		switch (property) {
			case 'Name':
				data.push(Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'Name', payload.Name));
				break;
			case 'Description':
				data.push(
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'Description', payload.Description)
				);
				break;
			case 'DueDate':
				data.push(Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'DueDate', payload.DueDate));
				break;
			case 'SectionId':
				data.push(
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.test, 'SectionId', payload.SectionId)
				);
				break;
			case 'Scopes':
				data.push(Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'Scopes', payload.Scopes));
				break;
			case 'Components':
				data.push(
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'Components', payload.Components)
				);
				break;
			case 'IsComponentOnly':
				data.push(
					Utility.getJsonPatchDocumentElement(
						jsonDocumentPatchOperations.replace,
						'IsComponentOnly',
						payload.IsComponentOnly
					)
				);
				break;
			case 'Documents': {
				//note:it checks if the document List is to add or replace (checking the first one is enough)
				//it should not be add and remove at the same time because it is replace (operation that we are changing)
				let operation = payload.Documents[0].checked
					? jsonDocumentPatchOperations.add
					: jsonDocumentPatchOperations.replace;
				data.push(
					Utility.getJsonPatchDocumentElement(
						operation,
						'Documents',
						payload.Documents.map((d) => d.id)
					)
				);
				break;
			}
			case 'scopeName':
				data.push(
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'scopeName', payload.scopeName)
				);
			case 'scopeDescription':
			data.push(
				Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'scopeDescription', payload.scopeDescription)
			);
			default:
				break;
		}
	});
	return data;
};
